import round from './round';

const getGesamtpreis = (zwischensumme, rabatt) => {
  return round(zwischensumme - rabatt);
};

export default getGesamtpreis;
